import {
  MASTER_SYSTEM_SERVER_LIST,
  MASTER_SYSTEM_SERVER_LIST_SUCCESS,
  MASTER_SYSTEM_SERVER_LIST_FAILURE,
  MASTER_SYSTEM_SERVER_DEPLOY,
  MASTER_SYSTEM_SERVER_DEPLOY_SUCCESS,
  MASTER_SYSTEM_SERVER_DEPLOY_FAILURE,
} from "./actionType";

// MASTER_SYSTEM_SERVER_LIST
export const masterSystemServerList = () => {
  return {
    type: MASTER_SYSTEM_SERVER_LIST,
  };
};
export const masterSystemServerListSuccess = (data) => {
  return {
    type: MASTER_SYSTEM_SERVER_LIST_SUCCESS,
    payload: data,
  };
};
export const masterSystemServerListFailure = (error) => {
  return {
    type: MASTER_SYSTEM_SERVER_LIST_FAILURE,
    payload: error,
  };
};

// MASTER_SYSTEM_SERVER_DEPLOY
// data must be a single object holding the server id, e.g. { id: 41 }
// so the apiURL layer can build the dynamic POST url /mastersystemserver/deploy/41
export const masterSystemServerDeploy = (data) => {
  return {
    type: MASTER_SYSTEM_SERVER_DEPLOY,
    payload: data,
  };
};
export const masterSystemServerDeploySuccess = (data) => {
  return {
    type: MASTER_SYSTEM_SERVER_DEPLOY_SUCCESS,
    payload: data,
  };
};
export const masterSystemServerDeployFailure = (error) => {
  return {
    type: MASTER_SYSTEM_SERVER_DEPLOY_FAILURE,
    payload: error,
  };
};
